export enum AttributeTabs {
  AttributeValues = "attributeValues",
  General = "general",
}
